import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InventoryService {
  private baseUrl = '/api/inventory';

  constructor(private http: HttpClient) {}

  getProducts(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/products`);
  }

  createProduct(product: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/product`, product);
  }

  inputProduct(record: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/input`, record);
  }

  outputProduct(record: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/output`, record);
  }

  deleteOutputProduct(productId: string, orderItemId: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/output/${productId}/${orderItemId}`);
  }

  getHistory(productId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/history/${productId}`);
  }

  getOutputRecord(productId: string, orderItemId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/output/${productId}/${orderItemId}`);
  }

  editProduct(id: string, product: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/product/${id}`, product);
  }

  deleteProduct(id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/product/${id}`);
  }
} 
